import { render, staticRenderFns } from "./DeviceManagementModifyJigou.vue?vue&type=template&id=47143c54&scoped=true&"
import script from "./DeviceManagementModifyJigou.vue?vue&type=script&lang=js&"
export * from "./DeviceManagementModifyJigou.vue?vue&type=script&lang=js&"
import style0 from "./DeviceManagementModifyJigou.vue?vue&type=style&index=0&id=47143c54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47143c54",
  null
  
)

export default component.exports